<template>
    <div class="contents">
        <div class="container-fluid">
            <BirthdayNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Statistik & Laporan
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <button v-on:click="exportLogs" class="btn px-15 btn-success text-white" style="display: inline-flex; margin: 5px">
                                <i class="fas fa-download fs-16"></i>
                                Export Laporan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <div class="mb-3">
                            <label>Range:</label>
                            <select v-model="range" @change="loadStats" class="form-control" style="width: 200px; display: inline-block; margin-left: 10px;">
                                <option value="week">Mingguan</option>
                                <option value="month">Bulanan</option>
                            </select>
                        </div>
                        <div v-if="stats" class="row mb-3">
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h5>Total Ulang Tahun</h5>
                                        <h3>{{ stats.total_birthdays }}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h5>Total Terkirim</h5>
                                        <h3>{{ stats.total_sent }}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h5>Total Gagal</h5>
                                        <h3>{{ stats.total_failed }}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <BirthdayLogsTable ref="logsTable" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BirthdayLogsTable from "@/components/tables/BirthdayLogs.vue";
import BirthdayNavigation from "@/components/birthday/Navigation.vue";

export default {
    components: {
        BirthdayLogsTable,
        BirthdayNavigation
    },
    data() {
        return {
            range: "month",
            stats: null
        };
    },
    methods: {
        async loadStats() {
            try {
                let response = await this.$store.dispatch("birthday/birthday_stats", { range: this.range });
                this.stats = response.data.data.stats;
            } catch (err) {
                this.$toast.error("Gagal memuat statistik");
            }
        },
        async exportLogs() {
            try {
                let response = await this.$store.dispatch("birthday/birthday_logs_export", { format: "csv" });
                // response.data is already a Blob when responseType is 'blob'
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'birthday_logs.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.$toast.success("Laporan berhasil diexport");
            } catch (err) {
                this.$toast.error("Gagal export laporan");
            }
        }
    },
    mounted() {
        this.loadStats();
    }
};
</script>

